export default __webpack_public_path__ + "static/media/dhcp.1ea365e6.png";